import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useStateMachine } from 'little-state-machine'

import { Store } from '../Scale'
import { Label, FieldWrapper } from '../Layout'
import { MAX_LENGTH, CharCounter } from '../CharCounter'

export function PersonFillingScaleWithOptions() {
  const { register, setValue, watch } = useFormContext()
  const { t } = useTranslation('translation')

  const personFillingScaleWithOptions = watch()

  const {
    state: { inquery },
  } = useStateMachine<Store>()

  React.useEffect(() => {
    if (inquery.defaultValues['-1']) setValue('-1', inquery.defaultValues['-1'])
    if (inquery.defaultValues['-3']) setValue('-3', inquery.defaultValues['-3'])
    if (inquery.defaultValues['-4']) setValue('-4', inquery.defaultValues['-4'])
  }, [inquery.defaultValues])

  return (
    <React.Fragment>
      <FieldWrapper>
        <Label htmlFor="person-filling-scale-with-options-1">
          {t('personFillingScaleWithOptions.1.title')}

          <select
            id="person-filling-scale-with-options-1"
            name="-1"
            ref={register({ required: 'required' })}
          >
            <option value="1">
              {t('personFillingScaleWithOptions.1.options.1')}
            </option>
            <option value="2">
              {t('personFillingScaleWithOptions.1.options.2')}
            </option>
            <option value="3">
              {t('personFillingScaleWithOptions.1.options.3')}
            </option>
            <option value="4">
              {t('personFillingScaleWithOptions.1.options.4')}
            </option>
          </select>
        </Label>
      </FieldWrapper>
      {personFillingScaleWithOptions[-1] === '3' && (
        <FieldWrapper>
          <Label htmlFor="person-filling-scale-with-options-3">
            <select
              id="person-filling-scale-with-options-3"
              name="-4"
              ref={register({ required: 'required' })}
            >
              <option value="1">
                {t('personFillingScaleWithOptions.2.options.1')}
              </option>
              <option value="2">
                {t('personFillingScaleWithOptions.2.options.2')}
              </option>
              <option value="3">
                {t('personFillingScaleWithOptions.2.options.3')}
              </option>
              <option value="4">
                {t('personFillingScaleWithOptions.2.options.4')}
              </option>
              <option value="5">
                {t('personFillingScaleWithOptions.2.options.5')}
              </option>
              <option value="6">
                {t('personFillingScaleWithOptions.2.options.6')}
              </option>
              <option value="7">
                {t('personFillingScaleWithOptions.2.options.7')}
              </option>
              <option value="8">
                {t('personFillingScaleWithOptions.2.options.8')}
              </option>
              <option value="9">
                {t('personFillingScaleWithOptions.2.options.9')}
              </option>
              <option value="10">
                {t('personFillingScaleWithOptions.2.options.10')}
              </option>
              <option value="11">
                {t('personFillingScaleWithOptions.2.options.11')}
              </option>
            </select>
          </Label>
        </FieldWrapper>
      )}
      {personFillingScaleWithOptions[-1] === '4' && (
        <FieldWrapper>
          <Label>
            {t('personFillingScaleWithOptions.3.title')}
            <textarea
              maxLength={MAX_LENGTH}
              name="-3"
              ref={register({ required: 'required' })}
            />
          </Label>
          <CharCounter length={personFillingScaleWithOptions[-3]?.length} />
        </FieldWrapper>
      )}
    </React.Fragment>
  )
}

export function PersonFillingScaleWithOptionsAlt() {
  const { register, setValue, watch } = useFormContext()
  const { t } = useTranslation('translation')

  const personFillingScaleWithOptionsAlt = watch()

  const {
    state: { inquery },
  } = useStateMachine<Store>()

  React.useEffect(() => {
    if (inquery.defaultValues['-1']) setValue('-1', inquery.defaultValues['-1'])
    if (inquery.defaultValues['-3']) setValue('-3', inquery.defaultValues['-3'])
  }, [inquery.defaultValues])

  return (
    <React.Fragment>
      <FieldWrapper>
        <Label htmlFor="person-filling-scale-with-options-alt-1">
          {t('personFillingScaleWithOptions.1.title')}

          <select
            id="person-filling-scale-with-options-alt-1"
            name="-1"
            ref={register({ required: 'required' })}
          >
            <option value="1">
              {t('personFillingScaleWithOptionsAlt.1.options.1')}
            </option>
            <option value="2">
              {t('personFillingScaleWithOptionsAlt.1.options.2')}
            </option>
            <option value="3">
              {t('personFillingScaleWithOptionsAlt.1.options.3')}
            </option>
            <option value="4">
              {t('personFillingScaleWithOptionsAlt.1.options.4')}
            </option>
            <option value="5">
              {t('personFillingScaleWithOptionsAlt.1.options.5')}
            </option>
          </select>
        </Label>
      </FieldWrapper>
      {personFillingScaleWithOptionsAlt[-1] === '5' && (
        <FieldWrapper>
          <Label>
            {t('personFillingScaleWithOptionsAlt.2.title')}
            <textarea
              name="-3"
              ref={register({ required: 'required' })}
              maxLength={MAX_LENGTH}
            />
          </Label>
          <CharCounter length={personFillingScaleWithOptionsAlt[-3]?.length} />
        </FieldWrapper>
      )}
    </React.Fragment>
  )
}
